export default "__VITE_ASSET__91f2a7b0__"